import { Component, uiElements, uiElement, uiEvent } from "@kluntje/core";
import { CookieSettingsCategory } from "Components/wec-m-cookie-settings-category/wec-m-cookie-settings-category";
import { CONSENT_CATEGORY_CHANGED_EVENT, ConsentCategoryChangedEvent } from "Constants/eventTypes";

export class CookieSettingsGroup extends Component {
  @uiElement(".wec-m-cookie-settings-category--category-toggle")
  groupToggle: CookieSettingsCategory;

  @uiElements(".wec-m-cookie-settings-category:not(.wec-m-cookie-settings-category--category-toggle)")
  settingsCategories: Array<CookieSettingsCategory>;

  get allCategoriesActive(): boolean {
    return this.settingsCategories.findIndex(settingsCategory => settingsCategory.consent === false) === -1;
  }

  afterComponentRender() {
    this.groupToggle.silentStateChange(this.allCategoriesActive);
  }

  @uiEvent("groupToggle", CONSENT_CATEGORY_CHANGED_EVENT)
  toggleChanged() {
    this.toggleAllCategories(this.groupToggle.consent);
  }

  toggleAllCategories(newConsentState: boolean) {
    this.settingsCategories.forEach(settingsCategory => {
      settingsCategory.consent = newConsentState;
    });
  }

  acceptAll() {
    this.toggleAllCategories(true);
  }

  saveAll(newConsentState?: boolean) {
    this.settingsCategories.forEach(settingsCategory => {
      settingsCategory.updateConsent(newConsentState);
    });
  }

  @uiEvent("settingsCategories", CONSENT_CATEGORY_CHANGED_EVENT)
  categoryChanged({ detail: consentEvent }: ConsentCategoryChangedEvent) {
    this.updateGroupToggleState(consentEvent.consent);
  }

  updateGroupToggleState(consentGiven: boolean) {
    if (consentGiven && this.allCategoriesActive) this.groupToggle.silentStateChange(true);
    if (!consentGiven && !this.allCategoriesActive) this.groupToggle.silentStateChange(false);
  }
}

customElements.define("wec-m-cookie-settings-group", CookieSettingsGroup);
